// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.list-group-item.selected{color:#fff;background:var(--color2)}
`, "",{"version":3,"sources":["webpack://./checkout/address-select.vue"],"names":[],"mappings":"AACA,0BACI,UAAA,CACA,wBAAA","sourcesContent":["\n.list-group-item.selected {\n    color: white;\n    background: var(--color2);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
